import TablaConciliacion from "../../../TablaConciliacion";

function TablaViaMontesDeMaria() {
  return <TablaConciliacion nombreUseCase="VIAMONTESDEMARIA" titulo="VIA MONTES DE MARIA" />;
}

export default TablaViaMontesDeMaria;
